import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChart2"><Path fillRule="evenodd" clipRule="evenodd" d="M1 3H23V5H21V18H13.8685L15.3868 20.2773L13.7226 21.3868L12 18.8028L10.2774 21.3868L8.61325 20.2773L10.1315 18H3V5H1V3ZM9 11H7V14H9V11ZM13 7V14H11V7H13ZM17 9H15V14H17V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChart2;
